import React, {Component} from 'react';
import {Button, Form, Table} from 'react-bootstrap'
import {Route} from 'react-router'
import ApiManager from '../../ApiManager'
import {withRouter, BrowserRouter, Switch, Redirect} from 'react-router-dom'
import {Link} from 'react-router-dom'
import DeleteIcon from 'mdi-react/DeleteIcon'
import ShowIcon from 'mdi-react/FileDocumentEditOutlineIcon'
import UrlIcon from 'mdi-react/FolderIcon'
class VideoListScreen extends React.Component {
  constructor(props){
      super(props)
      this.state = {
          videos: []
      }
  }
  componentDidMount(){
      ApiManager.fetchVideos(this.props.id).then(response => {
          this.setState({videos: response.data})
      })
  }
  deleteItem(id){
      var data = new FormData()
      data.append("id", id)
      data.append("table", "objects_cranes_video")
      ApiManager.deleteItem2(data).then(response => {
          var newObjects = this.state.videos.filter(object => object.id != id)
          this.setState({videos: newObjects})
      })
  }
  render() {
    var ListData = this.state.videos.map(video => {
        var showLink = "/object/cranes/videos/" + video.id
        var itemId = video.id
        return <tr><td>{video.id}</td><td>{video.name}</td><td><a href={video.url} target="_blank"><UrlIcon style={{cursor: 'pointer'}} size={24} color='gray'/></a></td><td><Link to={showLink}><ShowIcon style={{cursor: 'pointer'}} size={24} color='blue'/></Link><DeleteIcon style={{cursor: 'pointer'}} onClick={() => this.deleteItem(itemId)} size={24} color='red'/></td></tr>
    })
    return (
        <div>
        <Table striped bordered hover>
          <thead>
          <tr><th>#</th><th>Название</th><th>URL</th><th>Действия</th></tr>
          </thead>
          <tbody>
          {ListData}
          </tbody>
        </Table>
        </div>
    );
  }
}
export default VideoListScreen;